/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_shorts_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does my Shorts thumbnail look cropped or letterboxed?`)
};

const es_yt_shorts_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué mi miniatura de Shorts se ve recortada o con bandas negras?`)
};

const de_yt_shorts_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum wirkt mein Shorts-Thumbnail beschnitten oder mit schwarzen Balken?`)
};

const nl_yt_shorts_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom lijkt mijn Shorts-thumbnail bijgesneden of met zwarte balken?`)
};

const fr_yt_shorts_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi ma miniature de Short apparaît-elle recadrée ou avec des bandes noires ?`)
};

const it_yt_shorts_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché la miniatura del mio Short appare ritagliata o con bande nere?`)
};

const pt_br2_yt_shorts_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que a thumbnail do meu Shorts aparece cortada ou com faixas pretas?`)
};

const pt_yt_shorts_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que a miniatura do meu Short aparece cortada ou com faixas pretas?`)
};

const ja_yt_shorts_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortsのサムネイルがトリミングされたりレターボックスになったりするのはなぜ？`)
};

const zh_yt_shorts_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么我的 Shorts 缩略图看起来被裁剪或带有黑边？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_shorts_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_shorts_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_shorts_faq3_q", locale)
	if (locale === "en") return en_yt_shorts_faq3_q(inputs)
	if (locale === "es") return es_yt_shorts_faq3_q(inputs)
	if (locale === "de") return de_yt_shorts_faq3_q(inputs)
	if (locale === "nl") return nl_yt_shorts_faq3_q(inputs)
	if (locale === "fr") return fr_yt_shorts_faq3_q(inputs)
	if (locale === "it") return it_yt_shorts_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_yt_shorts_faq3_q(inputs)
	if (locale === "pt") return pt_yt_shorts_faq3_q(inputs)
	if (locale === "ja") return ja_yt_shorts_faq3_q(inputs)
	return zh_yt_shorts_faq3_q(inputs)
};